import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import useStyles from './styles';

function YearPicker({ setStartDate, setEndDate }) {
  const [date, setDate] = useState(moment());
  const [year, setYear] = useState(moment().format('YYYY'));
  const classes = useStyles();

  const handlePlus = () => {
    setDate(date.add(1, 'year'));
    formatInput();
  };

  const handleMinus = () => {
      setDate(date.subtract(1, 'year'));
    formatInput();
  };

  const formatInput = () => {
    setYear(date.format('YYYY'));
    handleRequest();
  };

  const handleRequest = () => {
    setStartDate(date.startOf('year').format());
    setEndDate(date.endOf('year').format());
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={() => handleMinus()}>
        <ArrowBackIcon />
      </Button>

      <TextField
        id="outlined-read-only-input"
        label="Ano de busca"
        value={`${year}`}
        InputProps={{
          readOnly: true,
          className: classes.inputDate,
        }}
        variant="outlined"
      />

      <Button variant="contained" color="primary" onClick={() => handlePlus()}>
        <ArrowForwardIcon />
      </Button>
    </>
  );
}

YearPicker.propTypes = {
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
};

export default YearPicker;
